import React from 'react';
import { Heading } from 'src/components/Form';
import { Images } from 'src/Tenants';
import {
  useSystemLevelNotifications,
  UseSystemLevelNotificationsReturn,
} from 'src/pages/Settings/CustomHooks/useSystemNotifications';
import '../../Settings.scss';

export const QRCodeSection: React.FC = () => {
  const { canAccessQRCode }: UseSystemLevelNotificationsReturn =
    useSystemLevelNotifications();

  if (!canAccessQRCode) return null;

  return (
    <div className="settingsQrcodeView">
      <Heading>Scan the QR Code from mobile app</Heading>
      <img src={Images.QRCode} className="settingsQrcodeImage" alt="QR Code for mobile app" />
    </div>
  );
};